import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import VideoShowcase from "@/components/VideoShowcase";
import Pricing from "@/components/Pricing";
import Gallery from "@/components/Gallery";
import TravelSection from "@/components/TravelSection";
import Testimonials from "@/components/Testimonials";
import Footer from "@/components/Footer";
import { motion } from "framer-motion";
import { Phone, Mail } from "lucide-react";
import { CONTACT } from "@/lib/api";

function About() {
  return (
    <section data-testid="about-section" className="lk-section px-6 md:px-12 lg:px-24 bg-[#0a0a0a] border-y border-[#D4AF37]/10">
      <div className="grid md:grid-cols-12 gap-12 items-center">
        <div className="md:col-span-5">
          <span className="text-xs uppercase tracking-[0.3em] text-[#D4AF37]">About Luxury Kingz</span>
          <h2 className="font-serif text-4xl md:text-5xl font-light mt-4 leading-tight">
            White-glove service.
            <br />
            <span className="italic gold-gradient-text">Royal-grade memories.</span>
          </h2>
        </div>
        <div className="md:col-span-7 space-y-5 text-zinc-300 leading-relaxed">
          <p>
            Luxury Kingz LLC is a North Charleston, SC based boutique studio offering more than equipment and a backdrop —
            we bring cinematic photo & 360° booths, attentive on-site hosts, and a curated atmosphere worthy of the moments
            you'll relive forever.
          </p>
          <p>
            And because the celebration doesn't end at the venue, we're also a full-service travel agency — planning the
            honeymoon, the retreat, and every escape in between.
          </p>
          <div className="grid sm:grid-cols-2 gap-6 pt-4">
            <a data-testid="about-phone" href={CONTACT.phoneHref} className="flex items-center gap-3 text-sm hover:text-[#D4AF37] transition-colors">
              <Phone className="w-4 h-4 text-[#D4AF37]" /> {CONTACT.phone}
            </a>
            <a data-testid="about-email" href={CONTACT.emailHref} className="flex items-center gap-3 text-sm hover:text-[#D4AF37] transition-colors">
              <Mail className="w-4 h-4 text-[#D4AF37]" /> {CONTACT.email}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#050505] min-h-screen text-white">
      <Navbar />
      <Hero />
      <Services />
      <VideoShowcase />
      <Pricing />
      <About />
      <TravelSection />
      <Gallery />
      <Testimonials />
      <Footer />
    </div>
  );
}
